import { render, staticRenderFns } from "./ScreenRecorder.vue?vue&type=template&id=14d9135a&scoped=true"
import script from "./ScreenRecorder.vue?vue&type=script&lang=js"
export * from "./ScreenRecorder.vue?vue&type=script&lang=js"
import style0 from "./ScreenRecorder.vue?vue&type=style&index=0&id=14d9135a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9135a",
  null
  
)

export default component.exports